import React from 'react'
import ReactMarkdown from 'react-markdown'
import styles from './styles.css'
import { Hero as Props } from '../schema'
import Map from '../Map'
import BackgroundImage from '#src/components/BackgroundImage'

const Hero: React.SFC<Props> = ({ image, title, titleColor, details, heroBody, location }) => {
  const heroTextColor = titleColor ? titleColor : '#ffffff'

  return (
    <div className={styles.wrapper}>
      <BackgroundImage
        containerClassName={styles.container}
        contentClassName={styles.banner}
        src={image.imageUrl}
        size="100vw"
      >
        <div className={styles.title} style={{ color: heroTextColor }}>
          {title}
        </div>
        <div className={styles.details} style={{ color: heroTextColor }}>
          {details}
        </div>
      </BackgroundImage>
      <div className={styles.contentContainer}>
        <div className={styles.meanContent}>
          <div className={styles.heroBody}>
            <ReactMarkdown source={heroBody} />
          </div>
        </div>
        {location && (
          <div className={styles.mapContainer}>
            <Map location={location} />
          </div>
        )}
      </div>
    </div>
  )
}

export default Hero
